import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from "react-router";
import { Route } from 'react-router-dom';
import AppConfigJson from '../Configuration/AppConfig';
import AuthorizeService from './AuthorizeService';
import UserService from '../Services/UserService';
import HttpErrorMessages from '../TechnicalPage/ErrorPageHandler/HttpErrorMessages/HttpErrorMessages';
import MainPageLayout from '../PageLayout/MainPagesLayout/MainPagesLayout';
import Loading from '../PageLayout/Loading';

export default class AuthorizeRoute extends Component {
  static propTypes = {
    path: PropTypes.any
  };

  constructor(props) {
    super(props);

    this.state = {
      authenticated: false,
      unauthorize: false,
      hasAppConsent: true
    };
    this.isMount = false;
  }

  componentDidMount = () => {
    this.isMount = true;
    AuthorizeService.subscribe(this.handleAuthentificationChange);
    AuthorizeService.signIn().then(() => {
      if (AuthorizeService.isAuthenticated()) {
        UserService.HasAppConsent().then((check) => {
          this.setState({ hasAppConsent: check });
        });
      } else {
        setTimeout(() => {
          if (this.isMount) {
            this.setState({ unauthorize: true });
          }
        }, 4000);
      }
    });
  }

  componentWillUnmount = () => {
    AuthorizeService.unsubscribe(this.handleAuthentificationChange);
    this.isMount = false;
  }

  handleAuthentificationChange = () => {
    if (AuthorizeService.isAuthenticated() && this.isMount) {
      this.setState({ authenticated: true });
    }
  }

  render() {
    if (!this.state.authenticated) {
      if (this.state.unauthorize) {
        return (<HttpErrorMessages httpCode='401' />);
      }

      return (
        <MainPageLayout>
          <Loading>
            {'Login ...'}
          </Loading>
        </MainPageLayout>
      );
    } else {
      if (!AppConfigJson.Features.IsAppConsentEnabled || this.state.hasAppConsent || (this.props.path && this.props.path == '/terms')) {
        return <Route {...this.props} />;
      }
      else {
        return <Redirect to="/terms" />;
      }
    }
  }
}
